import { render } from "./RequestMappingManage.vue?vue&type=template&id=ffd4d35e"
import script from "./RequestMappingManage.vue?vue&type=script&lang=js"
export * from "./RequestMappingManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__